/*eslint-disable*/
export default [
    'Africa',
    'NorthAmerica',
    'SouthAmerica',
    'Australia',
    'Antarctica',
    'Space'
]
